import { render, staticRenderFns } from "./improveAfterSalesInformation.vue?vue&type=template&id=71960bb7&scoped=true"
import script from "./improveAfterSalesInformation.vue?vue&type=script&lang=js"
export * from "./improveAfterSalesInformation.vue?vue&type=script&lang=js"
import style0 from "./improveAfterSalesInformation.vue?vue&type=style&index=0&id=71960bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71960bb7",
  null
  
)

export default component.exports